import { accountUserApi } from 'shared/api/requests/accountUser'
import { createAsyncAction } from 'shared/lib/redux'

export const setFusion = createAsyncAction(
  'accountUser/setFusion',
  async () => {
    const response = await accountUserApi.setFusion()

    return response.data
  },
  {
    errorMarkupOptions: {
      scope: 'home_tab',
      section: 'fusion',
    },
  },
)
